import React from 'react';
import { SuccessScene } from '../../components/SuccessScene';

export const AcceptInvitationSuccessScene = () => (
  <SuccessScene context="AcceptInvitationSuccessScene" />
);
